import {engineContext} from './context.js';

(function(global){
'use strict';
const VERSION='0.1.0-alpha';

function norm(x){
  x=x||{};
  return Object.freeze({
    symbol:x.symbol||null,
    scope:['OWNED','WATCHLIST','RESEARCH'].includes(x.scope)?x.scope:'RESEARCH',
    priority:['CRITICAL','HIGH','MEDIUM','REVIEW','LOW','NONE'].includes(x.priority)?x.priority:'NONE',
    readiness:['READY_FOR_DECISION','REVIEW','BLOCKED'].includes(x.readiness)?x.readiness:'REVIEW',
    thesisDrift:x.thesisDrift||'STABLE',
    eventWithinHours:Number.isFinite(x.eventWithinHours)?Math.max(0,x.eventWithinHours):null,
    staleEvidenceCount:Number.isFinite(x.staleEvidenceCount)?Math.max(0,Math.floor(x.staleEvidenceCount)):0
  });
}
function cadenceHours(input){
  const x=norm(input);
  if(x.scope==='OWNED'&&x.priority==='CRITICAL') return 6;
  if(x.scope==='OWNED'&&x.readiness==='BLOCKED') return 12;
  if(x.eventWithinHours!==null&&x.eventWithinHours<=24) return 12;
  if(x.thesisDrift==='MATERIAL_DRIFT') return 24;
  if(x.priority==='HIGH') return x.scope==='OWNED'?24:48;
  if(x.priority==='MEDIUM') return 72;
  if(x.staleEvidenceCount>0) return 72;
  if(x.scope==='WATCHLIST') return 168;
  return 336;
}
function reviewPlan(input,lastReviewedAt,now){
  const x=norm(input);
  const interval=cadenceHours(x);
  const elapsed=(Number.isFinite(lastReviewedAt)&&Number.isFinite(now))?Math.max(0,(now-lastReviewedAt)/3600000):null;
  const due=elapsed===null?true:elapsed>=interval;
  return Object.freeze({
    symbol:x.symbol,
    intervalHours:interval,
    due,
    urgency:interval<=12?'NOW':interval<=24?'SOON':interval<=72?'SCHEDULED':'LOW_FREQUENCY',
    tradeSignal:false
  });
}
function batch(items,lastReviewedBySymbol,now){
  const map=lastReviewedBySymbol||{};
  const rows=(Array.isArray(items)?items:[]).map(x=>reviewPlan(x,map[norm(x).symbol],now));
  return Object.freeze({
    due:Object.freeze(rows.filter(x=>x.due)),
    notDue:Object.freeze(rows.filter(x=>!x.due)),
    tradeSignal:false
  });
}
function selfTest(){
  const t=[],ok=(n,p)=>t.push({name:n,pass:!!p});
  ok('critical owned gets shortest cadence',cadenceHours({scope:'OWNED',priority:'CRITICAL'})===6);
  ok('blocked owned gets twelve hour cadence',cadenceHours({scope:'OWNED',readiness:'BLOCKED'})===12);
  ok('near event accelerates cadence',cadenceHours({scope:'WATCHLIST',eventWithinHours:12})===12);
  ok('material thesis drift accelerates cadence',cadenceHours({scope:'WATCHLIST',thesisDrift:'MATERIAL_DRIFT'})===24);
  ok('high owned cadence is daily',cadenceHours({scope:'OWNED',priority:'HIGH'})===24);
  ok('watchlist default cadence is weekly',cadenceHours({scope:'WATCHLIST'})===168);
  const now=100000000;
  ok('overdue review is due',reviewPlan({symbol:'A',scope:'WATCHLIST'},now-200*3600000,now).due===true);
  ok('recent review is not due',reviewPlan({symbol:'A',scope:'WATCHLIST'},now-24*3600000,now).due===false);
  const b=batch([{symbol:'A',scope:'WATCHLIST'},{symbol:'B',scope:'OWNED',priority:'CRITICAL'}],{A:now-10*3600000,B:now-10*3600000},now);
  ok('batch separates due and not-due',b.due.length===1&&b.notDue.length===1);
  ok('review planning remains non-trading',b.tradeSignal===false);
  return Object.freeze({passed:t.filter(x=>x.pass).length,total:t.length,tests:Object.freeze(t)});
}
const API={VERSION,norm,cadenceHours,reviewPlan,batch,selfTest};
try{API.selfTestResult=selfTest()}catch(e){API.bootstrapError=String(e&&e.stack||e)}
global.ZooInvestReviewCadenceEngine=Object.freeze(API);
})(engineContext);
